// extracted by mini-css-extract-plugin
export default {"underlinedSection":"underlinedSection_gy2h1s6"};